<template>
    <div class="form-groups">
        <div v-for="(field, idx) in formFields" :key="idx" :class="field.class">
            <ui-virtual-list
                v-if="field.type === 'ui-virtual-list'"
                :label="field.label"
                :name="`${field.name}`"
                :getter="field.getter"
                :searcher="field.searcher"
                :value="
                    field.value
                        ? field.value
                        : getValueFromObject(data, field.path)
                "
                :float-title="field.floatTitle"
                :selected-option-text="true"
                :disabled="field.disabled"
                @change="setValue(data, $event, field)"
            />
            <the-input
                v-else
                :id="`${field.name}`"
                :class="[{ disable: field.disabled }]"
                :type="'text'"
                :label="field.title"
                :name="`${field.name}`"
                :text="
                    field.text
                        ? field.text
                        : getValueFromObject(data, field.path)
                "
                :invalid="!!errors[field.path]"
                :invalidFeedback="errors[field.path]"
                :readonly="field.disabled"
                @input="setValue(data, $event, field)"
                :format="field.format"
            ></the-input>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        formFields: {
            type: Array,
            required: true
        },
        data: {
            type: Object,
            required: false
        },
        errors: {
            type: Object,
            default: () => ({})
        }
    },
    methods: {
        getValueFromObject(object, path) {
            return path.split('.').reduce((res, prop) => res[prop], object)
        },
        setValue(obj, value, field) {
            if (field.type === 'ui-virtual-list') {
                field.value = value
            }

            const a = field.path.split('.')
            let o = obj
            while (a.length - 1) {
                const n = a.shift()
                if (!(n in o)) o[n] = {}
                o = o[n]
            }
            o[a[0]] = value
        }
    }
}
</script>
